import { useQuery } from "@tanstack/react-query";
import { useDependencies } from "./useDependencies";
import { useSlug } from "./useSlug";

export const useGetUserLink = () => {
  const { documentationAreaController } = useDependencies();
  const { slug, isUserLink } = useSlug();

  const queryFn = async () => {
    if (!isUserLink || !slug) {
      return null;
    }

    const userLink = await documentationAreaController.getUserLink(slug);
    return userLink;
  };

  const { isLoading, data, error } = useQuery({
    queryKey: ["userLink", slug],
    queryFn,
    retry: false,
    // See useGetCustomerCustomization: remounting observers must not retrigger a failed request
    retryOnMount: false,
  });

  return {
    userLink: data,
    getUserLinkError: error,
    isGetUserLinkLoading: isLoading,
  };
};
